/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audio_Description_Export_Preset_SavedInputs */

const en_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" saved successfully`)
};

const fr_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Préréglage "${i?.name}" enregistré`)
};

const de_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" erfolgreich gespeichert`)
};

const it_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" salvata correttamente`)
};

const ru_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предустановка "${i?.name}" успешно сохранена.`)
};

const es_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El ajuste preestablecido "${i?.name}" se guardó correctamente`)
};

const zh_cn2_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预设“${i?.name}”已成功保存`)
};

const ja_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセット「${i?.name}」が正常に保存されました`)
};

const hi_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_audio_description_export_preset_saved = /** @type {(inputs: Audio_Description_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" salva com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset \"{name}\" saved successfully" |
*
* @param {Audio_Description_Export_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_saved = /** @type {((inputs: Audio_Description_Export_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_saved(inputs)
	if (locale === "de") return de_audio_description_export_preset_saved(inputs)
	if (locale === "it") return it_audio_description_export_preset_saved(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_saved(inputs)
	if (locale === "es") return es_audio_description_export_preset_saved(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_saved(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_saved(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_saved(inputs)
	return en_audio_description_export_preset_saved(inputs)
});